import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { fetchPolicies } from '../../features/admin/policySlice';
import InnerLoading from '../ui/InnerLoading';
import { FileText, Shield } from 'lucide-react';

const TermsOFUse = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const { policies, loading } = useSelector((state: RootState) => state.policySlice);
    useEffect(() => {
        dispatch(fetchPolicies())
    }, [dispatch])
    return (
        <div>
            <h3 className=' text-xl mb-4 font-semibold'>{t("terms-of-use")}</h3>
            <div className=' space-y-4'>
                {loading ? <InnerLoading /> :
                    policies?.map((policy: any, index: number) => (
                        <div
                            key={index}
                            className="bg-white shadow-sm rounded-2xl p-6 border border-gray-100 hover:shadow-md transition"
                        >
                            <div className="flex   gap-2 mb-3">
                                {index % 2 === 0 ? (
                                    <FileText className="w-5 h-5 shrink-0 text-primary" />
                                ) : (
                                    <Shield className="w-5 h-5 shrink-0 text-primary" />
                                )}
                                <p className="text-textSecond leading-relaxed">{policy.details}</p>
                            </div>
                            
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default TermsOFUse